import src from "IMAGE";
export default { src, width: 81, height: 156, blurWidth: 4, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAYAAADeM14FAAAAQElEQVR42k3MQQoAIAgEwM6VWS/pmPT/f9kaCh5G2EUtqnqAoRgbBBt6FLmkKMyAm4sFEoH9pFmYHmo8FX/6tx8t1mHgkUNV3gAAAABJRU5ErkJggg=="};
